// extracted by mini-css-extract-plugin
export var attribution = "_cv-4";
export var authorName = "_cv-5";
export var quote = "_cv-3";
export var testimonial = "_cv-2";
export var trustedBy = "_cv-0";
export var trustedByLabel = "_cv-1";